<template>
  <div>
    <common-table :url="url"
                  :table-columns="tableColumns"
                  :form-fields="formFields"
                  :operate="operate"
                  :permission="permission"
                  :searchs="searchs"
                  :buttons="buttons"
                  :auto-update="true"
                  ref="table">
    </common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "UsdtPayEnergy",
  components: {CommonTable},
  data(){
    return{
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      searchs:[
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        },
        {
          name: 'rechargeId',
          placeholder: '充值订单号',
          type: 'input',
        },
        {
          name: 'startTime',
          placeholder: '开始时间',
          type: 'dateTime'
        },
        {
          name: 'endTime',
          placeholder: '结束时间',
          type: 'dateTime'
        }
      ],
      permission:{
      },
      url: {
        get: '/usdtPayEnergy/listByCondition',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      },{
        field: 'username',
        label: '用户名',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'type',
        label: '下单类型',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '充值'
          }, {
            key: 2,
            value: '提现'
          }]
        },
        detail: false,
        width: '',
      },{
        field: 'dataId',
        label: '数据ID',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'receiveAddress',
        label: '接收资源地址',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'orderId',
        label: '订单id',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'balance',
        label: '余额(TRX)',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'orderMoney',
        label: '该订单消费金额(TRX)',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'resType',
        label: '资源类型',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'payNums',
        label: '租用数量',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'payUserName',
        label: '下单账号',
        show: true,
        detail: false,
        width: '',
      },{
        field: 'resLock',
        label: '类型',
        show: {
          type: 'tag',
          tags: [{
            key: 0,
            value: '不锁定'
          }, {
            key: 1,
            value: '锁定'
          }]
        },
        detail: false,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        detail: false,
        width: ''
      }],
      formFields: {
        addTitle: '添加订单',
        updateTitle: '修改订单',
        model: [{
        }],
      },
      operate: [
      ],
      buttons: []
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>
